import { isDevEnv } from "../../../utils/analyticsEnv";
import { FALLBACK_AVATAR_OPTIONS, getAvatarThumbSrc } from "../../../utils/profileAvatarCatalog";
import { SQUARES_ENTRANCE_FEE } from "../shared/squaresConstants";

/**
 * Dev-only SQUARES demo match (`/squares?match=squares-demo-match`): uses the real match-play UI with
 * scripted socket + API fixtures. Never shown on production (gated by {@link isDevEnv}).
 */
export const SQUARES_DEMO_MATCH_ENABLED = isDevEnv();

export const SQUARES_DEMO_MATCH_ID = "squares-demo-match";
export const SQUARES_DEMO_MATCH_NAME = "Mumbai Indians v Chennai Super Kings";
export const SQUARES_DEMO_COMPETITION = "Indian Premier League";
/** Lobby demo card → real match play for the demo fixture. */
export const SQUARES_DEMO_MATCH_FLOW_PATH = `/squares?match=${SQUARES_DEMO_MATCH_ID}`;
export const SQUARES_DEMO_OVER_NUMBER = 12;
export const SQUARES_DEMO_VIEWER_USER_ID = 9201;
export const SQUARES_DEMO_FORMAT = 20;
export const SQUARES_DEMO_MAX_OVERS = 20;

/** Scripted raw ball outcomes for the demo over (settlement / scoregrid). */
export const SQUARES_DEMO_BALL_RESULTS = ["1", "4", "0", "W", "2", "6"] as const;

const AVATAR = FALLBACK_AVATAR_OPTIONS.map((item) => getAvatarThumbSrc(item) || item.url || null);

export function isSquaresDemoMatchId(matchId: string | null | undefined): boolean {
    const id = String(matchId || "").trim();
    if (id === "proto-ind-wi") return true;
    if (!SQUARES_DEMO_MATCH_ENABLED) return false;
    return id === SQUARES_DEMO_MATCH_ID;
}

export function squaresDemoViewerAvatar(): string {
    return AVATAR[4] || "";
}

/** Believable 6×6 odds grid returned by the demo calculate-over-odds handler. */
export function buildSquaresDemoOddsGrid(): { cells: Record<string, Record<number, string>>; hasAnyOdds: true } {
    const RUN_LABELS = ["0", "1", "2", "3", "4", "5+"];
    const base: number[][] = [
        [5.4, 4.8, 4.2, 5.1, 6.2, 7.0],
        [3.6, 3.2, 3.0, 3.4, 3.9, 4.4],
        [3.1, 2.8, 2.6, 2.9, 3.2, 3.6],
        [3.8, 3.4, 3.1, 3.5, 4.0, 4.6],
        [4.6, 4.1, 3.7, 4.2, 4.8, 5.4],
        [6.2, 5.6, 5.0, 5.8, 6.6, 7.4],
    ];
    const cells: Record<string, Record<number, string>> = {};
    RUN_LABELS.forEach((runLabel, row) => {
        cells[runLabel] = {};
        for (let ball = 1; ball <= 6; ball += 1) {
            const odds = base[row]?.[ball - 1];
            cells[runLabel][ball] = odds != null ? odds.toFixed(2) : "3.00";
        }
    });
    return { cells, hasAnyOdds: true };
}

export function squaresDemoPoolEntrantCount(playCount?: number): number {
    return Math.max(4, playCount ?? 11);
}

export function squaresDemoFirstPlacePrize(): number {
    const n = squaresDemoPoolEntrantCount();
    const rake = n <= 6 ? 0.05 : 0.1;
    const share = 0.5;
    return Math.round(n * SQUARES_ENTRANCE_FEE * (1 - rake) * share);
}

/** Guest account for trying the demo without logging in. */
export function buildSquaresDemoGuestUserAccount() {
    return {
        id: String(SQUARES_DEMO_VIEWER_USER_ID),
        username: "Demo Player",
        player_name: "You",
        avatar: squaresDemoViewerAvatar(),
        wallet: {
            coins: "10000",
            rubies: "0",
        },
    };
}
